export const UserRoleAtributte = 'http://sercide.com/roles';
export enum UserRolesEnum {
  // PIC
  MDM_ADMIN = 'MDM_ADMIN',
  MDM_OPERATOR = 'MDM_OPERATOR',
  // No PIC
  MDM_NO_MDM = 'MDM_NO_MDM',
  // De momento no se usan
  MDM_APP_LECTURAS = 'MDM_APP_LECTURAS',
  MDM_VIEWER = 'MDM_VIEWER',
  // Otros roles que pueden venir de Auth0 pero no se usan en la aplicación
  INFRA_EXT_STG = "INFRA_EXT_STG",
  SABT_DISTRIBUTOR_ADMIN = "SABT_DISTRIBUTOR_ADMIN",
  STG_DISTRIBUTOR_ADMIN = "STG_DISTRIBUTOR_ADMIN"
}
